import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import toast from "../utils/toast-notification";
import ApiClient from "./../utils/api-client";
import { Logo } from "../components/Logo";

const ResetPassword = () => {
  const location = useLocation();
  const history = useHistory();
  const [submitting, setSubmitting] = useState(false);
  const token = new URLSearchParams(location.search).get("token") || "";

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    const target = e.target as typeof e.target & {
      password: { value: string };
      passwordRepeat: { value: string };
    };
    const password = target.password.value;
    if (password !== target.passwordRepeat.value) {
      toast.error("The two passwords do not match");
      return;
    }

    setSubmitting(true);
    const res: any = await ApiClient.resetPassword(token, password);
    setSubmitting(false);

    // The client returns the error object instead of throwing, so a failed
    // reset is recognised by the absence of the success message.
    if (res?.response?.data?.message) {
      toast.error(res.response.data.message);
      return;
    }
    toast.success(res?.message || "Password updated successfully");
    history.push("/login");
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <Logo className="max-w-full" />
          <p className="mt-6 text-center text-sm leading-5 text-gray-700">
            This password reset link is incomplete. Please request a new one.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Logo className="max-w-full" />
        <h2 className="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
          Choose a new password
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-5 text-gray-700"
              >
                New password
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  id="password"
                  type="password"
                  required
                  minLength={8}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>

            <div className="mt-6">
              <label
                htmlFor="passwordRepeat"
                className="block text-sm font-medium leading-5 text-gray-700"
              >
                Repeat new password
              </label>
              <div className="mt-1 rounded-md shadow-sm">
                <input
                  id="passwordRepeat"
                  type="password"
                  required
                  minLength={8}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>

            <div className="mt-6">
              <span className="block w-full rounded-md shadow-sm">
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:ring-indigo active:bg-indigo-700 transition duration-150 ease-in-out disabled:opacity-50"
                >
                  Set new password
                </button>
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
